(function (angular) {
	'use strict';

	angular
		.module('serviceLevelModule')
		.controller('FormK1AcknowledgementModal', [
			'close',
			'proceed',
			'ignoreClose',
			FormK1AcknowledgementModalFunction
		]);

	function FormK1AcknowledgementModalFunction(
		close,
		proceed,
		ignoreClose) {

		var formK1AcknowledgementModal = this;
		formK1AcknowledgementModal.close = close;
		formK1AcknowledgementModal.proceed = proceed;
		formK1AcknowledgementModal.ignoreClose = ignoreClose;
	}
})(window.angular);